@if ({ identifiedCompany: identifiedCompany$ | async }; as STATE) {
  <main class="personal-infos-form">
    <hgroup>
      <h2>Informations de l’entreprise</h2>
      <p>Consultez les informations de base de votre société.</p>
    </hgroup>

    <section class="personal-infos-form__company-recap">
      <ul>
        <li>
          <span aria-hidden="true">
            <mat-icon svgIcon="dgi-list-marker"></mat-icon>
          </span>
          NCC : {{ STATE.identifiedCompany?.ncc || '-' }}
        </li>

        <li>
          <span aria-hidden="true">
            <mat-icon svgIcon="dgi-list-marker"></mat-icon>
          </span>
          Raison sociale : {{ STATE.identifiedCompany?.name || '-' }}
        </li>
        <li>
          <span aria-hidden="true">
            <mat-icon svgIcon="dgi-list-marker"></mat-icon>
          </span>
          Régime d’imposition : {{ STATE.identifiedCompany?.taxRegime || '-' }}
        </li>
        <li>
          <span aria-hidden="true">
            <mat-icon svgIcon="dgi-list-marker"></mat-icon>
          </span>
          Direction de rattachement :
          {{ STATE.identifiedCompany?.taxDirection || '-' }}
        </li>

        <li>
          <span aria-hidden="true">
            <mat-icon svgIcon="dgi-list-marker"></mat-icon>
          </span>
          Centre des impôts :
          {{ STATE.identifiedCompany?.accountRoleLabel || '-' }}
        </li>

        <li>
          <span aria-hidden="true">
            <mat-icon svgIcon="dgi-list-marker"></mat-icon>
          </span>
          Statut de l’entreprise : {{ STATE.identifiedCompany?.statusLabel }}
        </li>
      </ul>
    </section>
    <hr />
    <hgroup>
      <h2>Adresse e-mail du gestionnaire principal</h2>
      <p>
        Renseignez l’adresse e-mail qui servira d'identifiant pour vous
        connecter.
      </p>
    </hgroup>

    <form
      class="form"
      [formGroup]="signupForm"
      [ngxsForm]="statePropertyPath"
      (ngSubmit)="proceedPersonalInfos()"
    >
      <!-- <div class="form__group">
        <label for="fullName" class="form__label"
          >Nom & Prénoms
          <span class="form__label--required">*</span>
        </label>
        <div class="form__item form__item--with-prefix">
          <span class="form__prefix">
            <mat-icon svgIcon="dgi-profile" color="primary"></mat-icon>
          </span>
          <input
            type="text"
            id="fullName"
            formControlName="fullName"
            class="form__input"
            placeholder="Ex. John Doe"
          />
        </div>

        @if (fullName?.touched && fullName?.errors?.required) {
          <mat-error
            [innerHtml]="'Ce champ est requis'"
            class="form__error-red"
          >
          </mat-error>
        }
        @if (fullName?.getError('customError'); as customError) {
          <mat-error [innerHtml]="customError" class="form__error-red">
          </mat-error>
        }
      </div> -->

      <div class="form__group">
        <label for="email" class="form__label"
          >Adresse électronique
          <span class="form__label--required">*</span>
        </label>
        <div class="form__item form__item--with-prefix">
          <span class="form__prefix">
            <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
          </span>
          <input
            type="email"
            id="email"
            formControlName="email"
            class="form__input"
            placeholder="Ex. john.doe@entreprise.com"
          />
        </div>
        @if (email?.touched && email?.errors?.required) {
          <mat-error
            [innerHtml]="'Ce champ est requis'"
            class="form__error-red"
          >
          </mat-error>
        }
        @if (email?.getError('customError'); as customError) {
          <mat-error [innerHtml]="customError" class="form__error-red">
          </mat-error>
        }
      </div>

      <!-- <div class="form__group">
        <label for="phoneNumber" class="form__label"
          >Téléphone
          <span class="form__label--required">*</span>
        </label>
        <input
          #phoneNumberInput
          (keypress)="validatePhoneNumberFn($event)"
          type="tel"
          id="phoneNumber"
          formControlName="phoneNumber"
          validatePhoneNumberFn="validatePhoneNumber;"
          class="form__input"
          placeholder="XX XXX XXX XX"
        />
        @if (phoneNumber?.touched && phoneNumber?.errors?.required) {
          <mat-error
            [innerHtml]="'Ce champ est requis'"
            class="form__error-red"
          >
          </mat-error>
        }
        @if (phoneNumber?.getError('customError'); as customError) {
          <mat-error [innerHtml]="customError" class="form__error-red">
          </mat-error>
        }
      </div> -->

      <div class="form__actions">
        <section class="personal-infos-form__buttons">
          <button
            button
            (click)="goBack()"
            aria-label="Retour"
            [variant]="'outline'"
          >
            <mat-icon svgIcon="dgi-arrow-left"></mat-icon>
          </button>
          <button
            button
            type="submit"
            [loading]="isSubmitting"
            [disabled]="signupForm.invalid || isSubmitting"
            size="lg"
            [fullWidth]="true"
          >
            Continuer
          </button>
        </section>
      </div>
    </form>
  </main>
}
